<script setup>
import useWindowDimensions from "@/util/useWindowDimensions.ts";
import { computed } from "vue";

const { isMobileViewport } = useWindowDimensions();

const zoneDisplay = computed(() => (isMobileViewport.value ? "none" : "block"));
</script>

<template>
  <div class="button-zones__zone button-zones__zone--top-left">
    <slot name="top-left"></slot>
  </div>
  <div class="button-zones__zone button-zones__zone--top-right">
    <slot name="top-right"></slot>
  </div>
  <div class="button-zones__zone button-zones__zone--bottom-left">
    <slot name="bottom-left"></slot>
  </div>
  <div class="button-zones__zone button-zones__zone--bottom-right">
    <slot name="bottom-right"></slot>
  </div>
  <div class="button-zones__zone button-zones__zone--center-left">
    <slot name="center-left"></slot>
  </div>
  <div class="button-zones__zone button-zones__zone--center-right">
    <slot name="center-right"></slot>
  </div>
</template>

<style scoped lang="scss">
@import "@/v2/styles/main";

.button-zones {
  &__zone {
    padding: var(--spacing-base);
    position: absolute;
    display: v-bind(zoneDisplay);
    z-index: var(--z-index-button-zones);

    > * + * {
      margin-top: var(--spacing-base);
    }

    &--top-left {
      top: 0;
      left: 0;
    }

    &--top-right {
      top: 0;
      right: 0;
    }

    &--bottom-left {
      bottom: 0;
      left: 0;
      z-index: var(--z-index-button-zones-bottom-left);
    }

    &--bottom-right {
      bottom: 0;
      right: 0;
    }

    &--center-left {
      top: calc(50% - var(--default-button-height) - var(--spacing-base));
      margin-top: calc(-1 * var(--spacing-base));
      left: 0;
    }

    &--center-right {
      top: calc(50% - var(--default-button-height) - var(--spacing-base));
      margin-top: calc(-1 * var(--spacing-base));
      right: 0;
    }

    @include massive-screen {
      // Ensure the buttons are in the center
      // of the interactable area
      &--top-left,
      &--top-right {
        top: calc(50% - var(--default-button-height) - var(--spacing-base));
        margin-top: calc(-1 * var(--spacing-base));
      }

      &--center-left,
      &--center-right {
        top: calc(50% - var(--default-button-height) - var(--spacing-base));
        margin-top: calc(0 * var(--spacing-base));
      }

      // Prevent back button from appearing
      // over the site navigator on massive screens
      &--bottom-left {
        z-index: var(--z-index-button-zones);
        bottom: calc(50% - var(--default-button-height) - var(--spacing-base));
      }

      &--bottom-right {
        display: flex;
        flex-direction: column;
        top: calc(50% - var(--spacing-base));
      }
    }
  }
}
</style>
